import { Component, Input } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
	selector: 'app-accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
	@Input() title : string;
	expanded : boolean = false;
	accordionId : string = uuidv4();


	onAccordionButtonClicked = (event : any) => {
		this.expanded = !this.expanded;
	}
}
